import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Briefcase } from "lucide-react";

export default function LoanDetailsStep({ form, setForm, loading, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-5 animate-fade-in">
      <div className="bg-gradient-to-r from-blue-50 to-cyan-50 border border-blue-200 rounded-xl p-4 mb-2 flex items-start gap-3">
        <Briefcase className="h-4 w-4 text-blue-800 flex-shrink-0 mt-0.5" strokeWidth={2.2} />
        <p className="text-sm text-blue-900 font-medium">Tell us about the loan you need support with</p>
      </div>

      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">Loan Type</Label>
        <select value={form.loan_type} onChange={e => setForm({...form, loan_type: e.target.value})} className="mt-2 w-full border-2 border-slate-200 rounded-xl px-4 py-3 text-sm font-medium focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none bg-white/50 transition-all" data-testid="loan-type-select">
          <option value="personal_loan">Personal Loan</option>
          <option value="home_loan">Home Loan</option>
          <option value="car_loan">Car Loan</option>
          <option value="education_loan">Education Loan</option>
          <option value="business_loan">Business Loan</option>
          <option value="credit_card">Credit Card EMI</option>
          <option value="other">Other</option>
        </select>
      </div>

      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">Lender Name</Label>
        <Input data-testid="lender-name-input" value={form.lender_name} onChange={e => setForm({...form, lender_name: e.target.value})} placeholder="e.g., HDFC Bank, ICICI Bank, SBI" className="mt-2 bg-white/50 border-slate-200 focus:border-blue-500 h-12" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">EMI Start Date</Label>
          <Input data-testid="emi-start-date-input" type="date" value={form.emi_start_date} onChange={e => setForm({...form, emi_start_date: e.target.value})} className="mt-2 bg-white/50 border-slate-200 focus:border-blue-500 h-12" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">EMI End Date</Label>
          <Input data-testid="emi-end-date-input" type="date" value={form.emi_end_date} onChange={e => setForm({...form, emi_end_date: e.target.value})} className="mt-2 bg-white/50 border-slate-200 focus:border-blue-500 h-12" />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">Total Loan Amount</Label>
          <Input data-testid="loan-amount-input" type="number" value={form.loan_amount} onChange={e => setForm({...form, loan_amount: e.target.value})} placeholder="500000" className="mt-2 bg-white/50 border-slate-200 focus:border-blue-500 h-12" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">Monthly EMI</Label>
          <Input data-testid="emi-amount-input" type="number" value={form.emi_amount} onChange={e => setForm({...form, emi_amount: e.target.value})} placeholder="15000" className="mt-2 bg-white/50 border-slate-200 focus:border-blue-500 h-12" />
        </div>
      </div>

      <button type="submit" disabled={loading} data-testid="submit-loan-details-btn" className="btn-gradient w-full h-14 rounded-xl font-semibold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 disabled:opacity-50">
        {loading ? <Loader2 className="h-5 w-5 animate-spin mx-auto" /> : <span>Continue to Payment</span>}
      </button>
    </form>
  );
}
